export default "__VITE_ASSET__DOyLYGV7__"